module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-container"
  }, [_c('div', [_c('gmap-map', {
    staticClass: "map-container",
    attrs: {
      "center": _vm.location,
      "zoom": 15
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.location,
      "clickable": true,
      "draggable": true
    },
    on: {
      "click": function($event) {
        _vm.center = _vm.location
      }
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "call-to-action-pitch"
  }, [_vm._v("Send me your building plans or the quantity in cubic meters you need and I will get you a price within 24 hours.")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_vm._v("\n    Email: "), _c('a', {
    attrs: {
      "href": "mailto:jonathan@siberianlarchwood.co.nz"
    }
  }, [_vm._v("jonathan@siberianlarchwood.co.nz")]), _c('br'), _c('br'), _vm._v("\n    Phone: "), _c('a', {
    attrs: {
      "href": "tel:0211098193"
    }
  }, [_vm._v("0211098193")]), _c('br'), _c('br'), _vm._v("\n    Address: "), _c('br'), _vm._v("81 Dunkirk Rd"), _c('br'), _vm._v("Panmure, Auckland, 1072\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-452bac2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 313
// module chunks = 3